const fonts = {
  heading: "Aeonik, sans-serif",
  body: "Aeonik, sans-serif",
  variable: "Switzer-Variable, sans-serif",
};

export default fonts;
